// Webpack Imports
import * as bootstrap from 'bootstrap';
import {tns} from "../node_modules/tiny-slider/src/tiny-slider"

(function () {
  'use strict';


  function scrollToObject(id, offset) {
    let offsetTop = 0;
    offsetTop = jQuery(id).offset()?.top - offset;
    if (offsetTop < 0) offsetTop = 0;
    window.scrollTo(0, offsetTop);
  }


  jQuery('.scroll-to-menu').on('click', function (e) {
    e.preventDefault();
    jQuery('.navbar-toggler').addClass('collapsed');
    jQuery('.navbar-collapse').removeClass('show');
    let id = jQuery(this).attr('href');
    if (id) {
      scrollToObject(id, 222);
    }
  });

  let url = window.location.href
  if (url.includes('wyjatkowy-prezent')) {
    scrollToObject('#wyjatkowy-prezent', 150);
  }

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
    el.addEventListener('submit', function (e) {
      var search = el.querySelector('input');
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  [].forEach.call(document.querySelectorAll('.js-dropdown-item'), (el) => {
    el.addEventListener('mouseover', function (e) {
      let menuContent = el.parentElement.querySelector('.dropdown-menu');
      menuContent = menuContent ? '<ul class="dropdown-menu show">' + menuContent.innerHTML + '</div>' : '';
      el.parentElement.parentElement.parentElement.querySelector('.menu-content').innerHTML = menuContent;
    });
    // el.addEventListener( 'mouseout', function ( e ) {
    //   console.log('mouse-over');
    //   el.parentElement.parentElement.parentElement.querySelector('.menu-content').innerHTML = '';
    // } );
  });

  // // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  // var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
  // var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
  // 	return new bootstrap.Popover( popoverTriggerEl, {
  // 		trigger: 'focus',
  // 	} );
  // } );
  //
  // const mainSliderCarousel = new bootstrap.Carousel('#mainSliderCarousel');
  // const mainPageCarousel = new bootstrap.Carousel('#mainpageCarousel');

  if (document.querySelector('.tiny-slider.main-content') !== null) {
    var slider = tns({
      container: '.tiny-slider.main-content',
      items: 1,
      slideBy: 'page',
      autoplay: false,
      // controlsContainer: ".nav-container",
      nav: true,
      navContainer: ".main-content-indicators",
      prevButton: '.main-content-prev-btn',
      nextButton: '.main-content-next-btn',
    });
  }

  if (document.querySelector('.tiny-slider.header-content') !== null) {
    var sliderHeader = tns({
      container: '.tiny-slider.header-content',
      items: 1,
      slideBy: 'page',
      autoplay: false,
      // controlsContainer: ".nav-container",
      nav: true,
      navContainer: ".header-content-indicators",
      prevButton: '.header-content-prev-btn',
      nextButton: '.header-content-next-btn',
    });
  }

  // if(document.querySelector('.check-selectall input')!==null) {
  //   document.querySelector('.check-selectall input').onclick = function () {
  //     console.log('checkall');
  //     document.querySelector('.allreact input[type="checkbox"]').prop('checked', this.checked);
  //
  //     // for(var i=0; i<inputs.length; i++) {
  //     //   inputs[i].checked = true;
  //     // }
  //   }
  // }
  jQuery('.check-selectall').on('click', 'input', function () {
    jQuery('.allreact input[type="checkbox"]').prop('checked', this.checked);
  })


  jQuery('.form-reservation .clinicSelect').on('change', function (event) {

    let form = jQuery(this).closest('.form-reservation');

    let clinic = form.find('.clinic').val();
    let currentTreatement = form.find('.treatement').val();

    // let map = {
    //   100000001: ['g1287611329', 'g1324444618','2746'],
    //   //100000001: ['12325', '12326', '11488', '12314'],
    //   //2: ['11488','12325','11608','11474','12079'],
    //   2: ['g1287611329', 'g1324444618', '2746','2026', '2027', '2028', '2029','2030','2031'],
    //   //100000002: ['12325', '12326','11488', '12106'],
    //   100000002: ['g1287611329', 'g1324444618','2746'],
    //   //100000004: ['12325', '12326', '11488'],
    //   100000004: ['g1287611329', 'g1324444618','2746'],
    //   4: [ '12325', '12326', '11488', '11608', '11474', '12079', '12106'],
    //   //100000003: ['12325', '12326', '11488', '11608'],
    //   100000003: ['g1287611329', 'g1324444618','2746'],
    //   //5: ['12325', '12326', '11488', '11608', '11474', '12079', '12314', '12106'],
    //   5: ['g1287611329', 'g1324444618', '2746'],//,'2028'],
    //   //1: ['11488','12325','12326','11608','11474','12079'],
    //   1: ['g1287611329', 'g1324444618', '2028', '2029', '2031'],//, '2027'
    //   3: ['g1287611329', 'g1324444618'],//, '2027', '2028', '2029', '2031'],
    //   100000005: ['g1287611329', 'g1324444618', '2027', '2028', '2029', '2031', '2627','2746','2642','2644'],
    // };


    let map = {
      100000001: ['g1287611329', 'g1324444618'],
      //100000001: ['12325', '12326', '11488', '12314'],
      //2: ['11488','12325','11608','11474','12079'],
      2: ['g1287611329', 'g1324444618'],
      //100000002: ['12325', '12326','11488', '12106'],
      100000002: ['g1287611329', 'g1324444618'],
      //100000004: ['12325', '12326', '11488'],
      100000004: ['g1287611329', 'g1324444618'],
      4: ['12325', '12326'],
      //100000003: ['12325', '12326', '11488', '11608'],
      100000003: ['g1287611329', 'g1324444618'],
      //5: ['12325', '12326', '11488', '11608', '11474', '12079', '12314', '12106'],
      5: ['g1287611329', 'g1324444618'],//,'2028'],
      //1: ['11488','12325','12326','11608','11474','12079'],
      1: ['g1287611329', 'g1324444618'],//, '2027'
      3: ['g1287611329', 'g1324444618'],//, '2027', '2028', '2029', '2031'],
      100000005: ['g1287611329', 'g1324444618'],
    };

    if (typeof optegraVisitsMap !== 'undefined' && optegraVisitsMap && Object.keys(optegraVisitsMap).length > 0) {
      map = optegraVisitsMap;
      //console.log('newVisitsMap', optegraVisitsMap);
    }

    let names = {
      12325: 'Kwalifikacja do korekcji wzroku - mam mniej niż 38 lat',
      12326: 'Kwalifikacja do korekcji wzroku - mam 38 lat lub więcej',
      g1287611329: 'Kwalifikacja do korekcji wzroku - mam mniej niż 38 lat',
      g2085911234: 'Kwalifikacja do korekcji wzroku - mam 38 lat lub więcej',
      g1324444618: 'Kwalifikacja do korekcji wzroku - mam 38 lat lub więcej',
      2646: 'Kwalifikacja do korekcji wzroku - mam mniej niż 38 lat',
      2647: 'Kwalifikacja do korekcji wzroku - mam 38 lat lub więcej',
      11608: 'Kwalifikacja - operacja stożka rogówki',
      2026: 'Kwalifikacja - okuloplastyka',
      2027: 'Kwalifikacja - operacja stożka rogówki',
      2030: 'Kwalifikacja - siatkówka',
      11474: 'Kwalifikacja - operacja usunięcia zaćmy (lekarz)',
      2028: 'Kwalifikacja - operacja usunięcia zaćmy (lekarz)',
      11488: 'Konsultacja okulistyczna',
      g95492050: 'Kompleksowe badanie wzroku',
      2746: 'Kompleksowe badanie wzroku',
      2827: 'Kompleksowe badanie wzroku',
      2641: 'Konsultacja okulistyczna z diagnostyką podstawową - dr n. med.',
      2642: 'Konsultacja okulistyczna z diagnostyką podstawową - lekarz specjalista',
      2643: 'Konsultacja okulistyczna z diagnostyką rozszerzoną - dr n. med.',
      2644: 'Konsultacja okulistyczna z diagnostyką rozszerzoną - lekarz specjalista',
      // 12314: 'Szybka kwalifikacja z ekspertem',
      // 2627: 'Szybka kwalifikacja z ekspertem'
    }

    /*
      100000001 katowice
      2 krakow
      100000002 lublin
      100000004 lodz
      4 poznan
      100000003 rzeszow
      5 szczecin
      1 warszawa ochota
      3 wroclaw
      100000005 warszawa wilanow


    11488 - Konsultacja okulistyczna
    11201 / 2024 - Kwalifikacja - laserowa korekcja wzroku (lekarz)
    12281 / 2025 - Kwalifikacja - laserowa korekcja wzroku 38+ (lekarz)
    2026 - Kwalifikacja - okuloplastyka
    11608 / 2027 - Kwalifikacja - operacja stożka rogówki
    11474 / 2028 - Kwalifikacja - operacja usunięcia zaćmy (lekarz)
    12079 / 2029 - Kwalifikacja - refrakcyjna wymiana soczewki
    12106 - / 2031 - Kwalifikacja - wszczepienie soczewki fakijnej



     */

    let arr = map[clinic];

    form.find('option.treatementReservation').each(function () {
      jQuery(this).remove();
    });

    let isFirst = true;
    let select = form.find('.treatement');

    // console.log('clinicMap',arr)

    arr.forEach((serviceId) => {
      if (names[serviceId] !== undefined && names[serviceId].length > 0) {
        var opt = document.createElement('option');
        opt.innerHTML = names[serviceId];
        opt.value = serviceId;
        opt.className = "treatementReservation tr-" + serviceId;
        select.append(opt)
      }
      // else {
      //   console.log('serviceId not match', serviceId);
      //   console.log('names not match', names[serviceId]);
      // }
    });

  });

  jQuery(document).on('submit', '.form-reservation', function (event) {
    event.preventDefault();
    let form = jQuery(this);
    const queryString = ''; //window.location.search;
    let clinic = form.find('.clinic').val();
    let treatement = form.find('.treatement').val();
    if (treatement !== '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'select_city_service',
        'city': form.find('.clinic').text(),
        'service': form.find('.treatement').text()
      });
      let url = '';
      if (clinic === '2') {
        url = 'https://rejestracjaonline.optegra.com.pl/krakow/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '100000005' || clinic === '1') {
        url = 'https://rejestracjaonline.optegra.com.pl/warszawa-kliniki/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '100000001') {
        url = 'https://rejestracjaonline.optegra.com.pl/katowice/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '100000003') {
        url = 'https://rejestracjaonline.optegra.com.pl/rzeszow/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '100000002') {
        url = 'https://rejestracjaonline.optegra.com.pl/lublin/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '100000004') {
        url = 'https://rejestracjaonline.optegra.com.pl/lodz/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '5') {
        url = 'https://rejestracjaonline.optegra.com.pl/szczecin/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '3') {
        url = 'https://rejestracjaonline.optegra.com.pl/wroclaw/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else if (clinic === '4') {
        url = 'https://rejestracjaonline.optegra.com.pl/poznan/wizyta-' + treatement + '/dowolny-specjalista/wybor-terminu-wizyty' + queryString;
      } else {
        url = 'https://rejestracja.optegra.com.pl/promocja-' + treatement + '-' + clinic + '.html' + queryString;
      }
      window.open(url, '_blank').focus();
    } else {
    }

  });


  function clickHandlerYt(event) {

    // Get the video link
    let link = event.target.closest('[data-youtube]');
    if (!link) return;

    // Prevent the URL from redirecting users
    event.preventDefault();

    // Get the video ID
    let id = link.getAttribute('data-youtube');

    let time = link.getAttribute('data-time');

    // Create the player
    let player = document.createElement('div');
    if (!time) {
      player.innerHTML = `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    } else {
      player.innerHTML = `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&start=${time}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    }

    // Inject the player into the UI
    link.replaceWith(player);

  }

// Detect clicks on the video thumbnails
  document.addEventListener('click', clickHandlerYt);


  // jQuery('.form-reservation.clinicSelectBlock').on('change', function(event){
  //
  //   let clinic = jQuery('.form-reservation-block .clinic').val();
  //   let currentTreatement = jQuery('.form-reservation-block .treatement').val();
  //
  //   let map = {
  //     100000001: ['11488','12325'],
  //     2: ['11488','12325','11608','11474','12079'],
  //     100000002: ['11488','12325'],
  //     100000004: ['11488','12325','12326'],
  //     4: ['11488','12325','11608','11474','12079'],
  //     100000003: ['11488','12325','12326','11608'],
  //     5: ['11488','12325','12326','11608','11474','12079'],
  //     1: ['11488','12325','12326','11608','11474','12079'],
  //     3: ['11488','12325','12326','11608','11474','12079'],
  //     100000005: ['11488','12325','11608','11474','12079'],
  //
  //   };
  //
  //   let arr = map[clinic];
  //
  //   if(jQuery.inArray(currentTreatement,arr)>=0){
  //
  //     jQuery('.form-reservation-block .treatement option.tr-'+currentTreatement).prop('selected',true);
  //   }
  //   else{
  //     jQuery('.form-reservation-block .treatement option:first').prop('selected',true);
  //   }
  //   jQuery('.form-reservation-block').find('.treatementReservation').each(function(){
  //
  //     let val = jQuery(this).val();
  //
  //     if(jQuery.inArray(val, arr)>=0){
  //       jQuery(this).show();
  //     }
  //     else{
  //       jQuery(this).hide();
  //     }
  //   });
  //
  // });

  // jQuery(document).on('click','.form-reservation-block-submit', function(event){
  //   event.preventDefault();
  //   let clinic = jQuery('.form-reservation-block').find('.clinic').val();
  //   let treatement = jQuery('.form-reservation-block').find('.treatement').val();
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     'event': 'select_city_service',
  //     'city': jQuery('.form-reservation-block').find('.clinic').text(),
  //     'service': jQuery('.form-reservation-block').find('.treatement').text()
  //   });
  //   if(clinic==='2') {
  //     window.location.href = 'https://rejestracjaonline.optegra.com.pl/krakow/wybor-powodu-wizyty';
  //   }
  //   else if(clinic==='100000005'){
  //     window.location.href = 'https://rejestracjaonline.optegra.com.pl/warszawa/wybor-powodu-wizyty';
  //   }
  //   else{
  //     window.location.href = 'https://rejestracja.optegra.com.pl/promocja-' + treatement + '-' + clinic + '.html';
  //   }
  //
  // });


})();
